import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DynamicFormComponent } from "../../common/dynamic-form/dynamic-form.component";

@Component({
  selector: "app-form-modal",
  standalone: true,
  imports: [CommonModule, DynamicFormComponent],
  templateUrl: "./form-modal.component.html",
  styleUrl: "./form-modal.component.scss",
})
export class FormModalComponent implements OnInit {
  @Input()
  fields: any = [];

  @Input()
  model: any;

  @Input()
  title: string = "";

  @Input()
  buttonText: any = {
    primary: "Add",
    secondary: "Cancel",
  };
  isActive: boolean = false;

  activeModal = inject(NgbActiveModal);
  dynamicForm: any = new FormGroup({});

  ngOnInit(): void {
    if (this.model) {
      // Clear existing controls
      Object.keys(this.dynamicForm.controls).forEach((key) => {
        this.dynamicForm.removeControl(key);
      });

      // Add new controls based on selected provider
      this.fields.forEach((field: any) => {
        this.dynamicForm.addControl(
          field.key,
          new FormControl(
            "",
            field.validations?.required ? Validators.required : []
          )
        );
      });

      this.dynamicForm.patchValue(this.model);
    }
  }

  close() {
    this.activeModal.close(this.dynamicForm.value);
  }
}
